import * as React from "react";

import { ReploLogoSymbol } from "@svg/replo-logo-symbol";

interface StarterProjectsModalHeaderProps {
  title: string;
}

export function StarterProjectsModalHeader({
  title,
}: StarterProjectsModalHeaderProps) {
  return (
    <div className="md:px-12 md:pt-12 md:relative">
      <div className="flex flex-col items-center gap-3 md:block">
        <ReploLogoSymbol className="size-7 text-default md:size-9 md:absolute md:left-12 md:top-12" />
        <h1 className="header-h2 md:header-h1 text-default text-center leading-tight">
          {title}
        </h1>
      </div>
    </div>
  );
}
